module.exports = __webpack_public_path__ + "static/media/USDC.c76b33ca.png";